'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Sidebar = require('@/components/Sidebar');

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _Ad = require('@/customized-core/Ad.vue');

var _Ad2 = _interopRequireDefault(_Ad);

var _SidebarAboutBuffer = require('@/customized-core/SidebarAboutBuffer.vue');

var _SidebarAboutBuffer2 = _interopRequireDefault(_SidebarAboutBuffer);

var _Nicklist = require('@/customized-core/Nicklist.vue');

var _Nicklist2 = _interopRequireDefault(_Nicklist);

var _UserBox = require('@/customized-core/UserBox.vue');

var _UserBox2 = _interopRequireDefault(_UserBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    mixins: [_Sidebar2.default],
    props: ['messageToProp', 'ml'],
    methods: {
        closeSidebar: function closeSidebar() {
            if (!event.target.closest('.kiwi-sidebar-inner-wrap')) {
                this.$state.$emit('sidebar.close');
            }
        }
    },
    components: {
        Ad: _Ad2.default,
        SidebarAboutBuffer: _SidebarAboutBuffer2.default,
        Nicklist: _Nicklist2.default,
        UserBox: _UserBox2.default
    }
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/Sidebar.vue
// module id = hkqu
// module chunks = 1